<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 11:21:28
 * @LastEditTime: 2020-05-18 14:10:16
 * @Description: 头部标题
 -->
<template>
  <div class="head-title">
    <p class="title">{{ paperName }}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HeadTitle',
  computed: {
    ...mapGetters({
      paperName: 'createPaperStore/paperName',
    }),
  },
};
</script>

<style lang="less" scoped>
.head-title {
  width: 100%;

  > .title {
    margin-top: 20px;
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: bold;
  }
}
</style>
